export var HS_CHATFLOW_PRIVATE_ENQUIRY = "hs_private_enquiry";
export var HS_CHATFLOW_MORE_PRODUCT_INFORMATION = "hs_more_product_information";
export var HS_CHATFLOWS = [HS_CHATFLOW_PRIVATE_ENQUIRY, HS_CHATFLOW_MORE_PRODUCT_INFORMATION];